export const profile = {
  name: "Girish Kumar Goyal",
  title: "Builder · Programmer · Reader · Writer · Student of Systems",
  identityRoles: ["Builder", "Programmer", "Reader", "Writer", "Student"],
  headline: "I build software systems, solve algorithmic problems, write a book and technical essays, and study history and systems.",
  location: "India",
  email: "gk.goyal.0.03@gmail.com",
  profileImage: "/profile.jpg",
  
  introduction: [
    "I am a software engineer, writer, and reader based in India. I focus on core systems programming in C/C++, algorithmic problem solving, LaTeX technical writing, and researching biological and historical systems.",
    "I completed my B.Tech in Computer Science & Engineering in 2022. Since then, I have spent my time building independent software systems, authoring a book manuscript on biology, solving algorithmic problems on Codeforces, and maintaining a digital catalogue of physical books.",
    "I value direct, disciplined work: learning the core fundamentals from first principles, writing clearly to explain ideas, and building software that is simple, deterministic, and dependable."
  ],

  whatIDo: [
    {
      code: "01",
      pillar: "BUILD",
      title: "Software Systems & Tooling",
      description: "I build reliable command-line utilities in C, LaTeX typesetting systems, and deterministic web applications with minimal abstractions and zero backend bloat.",
      relatedRoute: "/work"
    },
    {
      code: "02",
      pillar: "LEARN",
      title: "Disciplined Interdisciplinary Study",
      description: "I systematically study Indian and world history, constitutional polity, public administration, and political economy (UPSC / SSC curriculum foundations).",
      relatedRoute: "/learning"
    },
    {
      code: "03",
      pillar: "READ",
      title: "Personal Digital Library",
      description: "I maintain an active catalogue of canonical works spanning classical statecraft (Kautilya, Machiavelli), philosophy (Stoicism, Kuhn), macro-history (Durant), and computing (SICP, CLRS).",
      relatedRoute: "/reading"
    },
    {
      code: "04",
      pillar: "WRITE",
      title: "Book Manuscript & Essays",
      description: "I am authoring an in-progress book manuscript synthesizing systems and ideas, alongside essays on software simplicity and algorithmic invariants.",
      relatedRoute: "/writing"
    },
    {
      code: "05",
      pillar: "EXPLORE",
      title: "Algorithmic Precision & Products",
      description: "I solve complex algorithmic challenges on Codeforces (Candidate Master · max rating 2013) and develop independent software tools.",
      relatedRoute: "/work"
    }
  ],

  philosophy: [
    {
      code: "01",
      principle: "Understand Before Building",
      reflection: "Master the fundamental principles of a problem before writing code. Clarity in thought produces clean code."
    },
    {
      code: "02",
      principle: "Learn Across Disciplines",
      reflection: "Studying systems across biology, history, and computing reveals common structural patterns in how complex systems function."
    },
    {
      code: "03",
      principle: "Build From First Principles",
      reflection: "Prefer lightweight, deterministic, and durable tools over fragile dependencies and unnecessary abstractions."
    },
    {
      code: "04",
      principle: "Write to Clarify Thinking",
      reflection: "Writing forces clarity. If you cannot explain a technical concept simply in prose, you do not yet fully understand it."
    },
    {
      code: "05",
      principle: "Read Primary Texts Deeply",
      reflection: "Engage with foundational textbooks and original authors directly rather than relying solely on high-level summaries."
    }
  ],

  interests: [
    {
      category: "Engineering & Computing",
      items: ["Systems Programming (C / C++)", "Competitive Programming", "POSIX Utilities", "Web Systems", "LaTeX Publishing"]
    },
    {
      category: "History & Governance",
      items: ["Ancient Indian Statecraft (Arthashastra)", "Constitutional Polity", "World History", "Political Economy"]
    },
    {
      category: "Thought & Literature",
      items: ["Biological Systems", "Philosophy of Science", "Classical Literature", "Book Authoring"]
    }
  ],

  currently: [
    { label: "BUILDING", status: "Independent Systems & Developer Tooling" },
    { label: "WRITING", status: 'Book Manuscript: "Biology through Curiosity : Questions that became Knowledge"' },
    { label: "STUDYING", status: "History & Constitutional Polity" },
    { label: "READING", status: "Computing & Classical History Texts" },
    { label: "ENGINEERING", status: "Algorithmic Problem Solving & C Programming" }
  ],

  education: {
    degree: "B.Tech in Computer Science & Engineering",
    institution: "GL Bajaj Group of Institutions, Mathura",
    period: "2018 – 2022",
    focus: "Core CS, Algorithms, Data Structures, Operating Systems & Compiler Design"
  },

  socialLinks: [
    {
      name: "GitHub",
      url: "https://github.com/Girish-1-Goyal",
      username: "Girish-1-Goyal"
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/girish-kumar-goyal-189152198/",
      username: "girish-kumar-goyal"
    },
    {
      name: "Codeforces",
      url: "https://codeforces.com/profile/epsilon_xd",
      username: "epsilon_xd (Max Rating: 2013)"
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/girish_k_goyal/",
      username: "girish_k_goyal"
    },
    {
      name: "Twitter / X",
      url: "https://x.com/GirishkumarGoy5",
      username: "@GirishkumarGoy5"
    },
    {
      name: "Email",
      url: "mailto:gk.goyal.0.03@gmail.com",
      username: "gk.goyal.0.03@gmail.com"
    }
  ]
};
